"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPostalCode = void 0;
/** Spanish postal codes are five digits; the first two are the province (01–52). */
const POSTAL_CODE_LENGTH = 5;
/**
 * A stored zipcode as the text a delivery label prints.
 *
 * The model keeps zipcodes as NUMBERS on purpose (a zone lists the ones it
 * covers, and the match is numeric), so a province 01–09 loses its leading
 * zero in storage: Poblenou is the number 8018. Everything that shows or sends
 * a postal code — the proposal sidebar, the order detail, the backoffice
 * order modal, MRP's customer address — goes through this one rule instead of
 * each restoring the zero on its own, or forgetting to.
 */
const formatPostalCode = (zipcode) => String(zipcode).padStart(POSTAL_CODE_LENGTH, '0');
exports.formatPostalCode = formatPostalCode;
//# sourceMappingURL=postal-code.js.map